import { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarCheck, DollarSign, Gem, Repeat } from 'lucide-react';
import { DASH, authHeader } from '../api';
import { StatCard, Spinner, fmtMoney } from '../ui';

const OverviewSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${DASH}/overview`, { headers: authHeader() })
      .then((res) => mounted && setData(res.data))
      .catch(() => mounted && setError('Could not load overview metrics.'))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);

  if (loading) return <Spinner label="Loading overview…" />;
  if (error) return <div data-testid="overview-error" className="text-sm text-red-700">{error}</div>;

  return (
    <div data-testid="wellness-admin-section-overview" className="space-y-6">
      <div>
        <h2 className="text-2xl tracking-tight" style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800, color: '#0d1f15' }}>
          Overview
        </h2>
        <p className="text-sm text-[#5a7062] mt-1">Live snapshot of today's business.</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard testId="stat-bookings-today" label="Bookings Today" value={data.bookings_today} icon={CalendarCheck} />
        <StatCard testId="stat-revenue-today" label="Revenue Today" value={fmtMoney(data.revenue_today)} icon={DollarSign} accent="#d97736" />
        <StatCard testId="stat-sessions-outstanding" label="Sessions Outstanding" value={data.sessions_outstanding} icon={Gem} />
        <StatCard testId="stat-mrr" label={`MRR (${data.active_memberships} active)`} value={fmtMoney(data.mrr)} icon={Repeat} accent="#d97736" />
      </div>
    </div>
  );
};

export default OverviewSection;
